import React from 'react';
import { CREATOR_TERMS_URL } from '../design/data/creatorTerms';

/**
 * /start's last step, above the finish buttons, always (13 Oct 2026): unticked
 * to start, and finishing waits for it. "Creator Terms" opens the published
 * Terms in a new tab; a click on the link doesn't tick the box.
 */
export default function CreatorTermsCheckbox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-2.5 mb-4 cursor-pointer select-none text-sm" style={{ color: '#374151' }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-[18px] w-[18px] flex-shrink-0 cursor-pointer"
        style={{ accentColor: '#059669' }}
      />
      <span>
        I agree to the ShoutOut{' '}
        <a
          href={CREATOR_TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 font-medium"
          style={{ color: '#047857' }}
        >
          Creator Terms
        </a>
      </span>
    </label>
  );
}
